import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import HomePage from "../views/HomePage.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css"; // nprogress样式文件
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush
    .call(this, location)
    .catch((error) => console.log("error", error));
};
const routerrReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return routerrReplace
    .call(this, location)
    .catch((error) => console.log("error", error));
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },

  {
    path: "/index",
    name: "index",
    component: HomePage,
  },

  /*{
    path: "/eipLogin",
    name: "eipLogin",
    component: () =>
      import(/!* webpackChunkName: "LoginView" *!/ "../views/EipLogin.vue"),

  }*/
];

const router = new VueRouter({
  routes,
});

//当路由开始跳转时
router.beforeEach((to, from, next) => {
  // 开启进度条
  NProgress.start();
  next();
});
//当路由跳转结束后
router.afterEach(() => {
  // 关闭进度条
  NProgress.done();
});

export default router;
